import { render, staticRenderFns } from "./catsActions.vue?vue&type=template&id=6b9228c6&"
import script from "./catsActions.vue?vue&type=script&lang=js&"
export * from "./catsActions.vue?vue&type=script&lang=js&"
import style0 from "./catsActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports